const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

/**
 * After a successful company auth (magic link or OAuth), check whether onboarding
 * is complete and navigate accordingly.  Call with the raw JWT string.
 *
 * Resolves when navigation has been called.
 */
export async function redirectAfterCompanyAuth(token, navigate) {
    try {
        const res = await fetch(`${API}/api/company/onboarding/status`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
            const data = await res.json();
            if (!data.completed) {
                navigate("/company/onboarding", { replace: true });
                return;
            }
        } else if (res.status === 401 || res.status === 403) {
            navigate("/login?error=auth", { replace: true });
            return;
        }
    } catch {
        // Network error — fall through to dashboard; the dashboard will re-check
    }
    navigate("/company/matches", { replace: true });
}
